<template>
    <div id="services-intro-wrapper" class="services-intro-wrapper">
        <div id="services-intro" class="services-intro">
            <template
                v-for='service in filteredServiceList'
            >
                <service-intro-item
                    :key="service.type"
                    :type="service.type.includes('cloud') ? 'cloud' : 'sim'"
                    :title="service.title"
                    :subtitle="service.subtitle"
                    :desc="service.desc"
                    :navigateTo="()=>goSubscription( service.type )"
                >
                    <template v-slot:slot-pc-image>
                        <img :src="service.pcImageSrc"/>
                    </template>
                    <template v-slot:slot-mobile-image>
                        <img :src="service.mobileImageSrc"/>
                    </template>
                </service-intro-item>
            </template>
        </div>
        <features-intro :features-list="currentFeaturesList" />

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import router from '@/router';
import ServiceIntroItem from './components/ServiceIntroItem.vue';
import FeaturesIntro from './components/FeaturesIntro.vue';
import { servicesList, featuresList, IProductIntroduction } from './lib';
import { mapGetters } from 'vuex';

export default Vue.extend({

    components: {
        ServiceIntroItem,
        FeaturesIntro
    },

    data () {

        return {
            servicesList
        };

    },

    methods: {

        async goSubscription ( type: 'cloud-plan' | 'sim-plan' ) {

            try {

                switch ( type ) {

                    case 'cloud-plan':
                        await router.push({
                            name: 'cloud-plan'
                        });
                        break;
                    case 'sim-plan':{

                        if ( this.userStatus === 'login' ) {

                            await router.push({
                                name: 'select-sim-card'
                            });

                        } else {

                            await router.push({
                                name: 'sim-plan-list',
                            });

                        }

                        break;

                    }

                }

            } catch ( error ) {

                console.error( 'error when navigating', error );

            }

        },
    },

    computed: {
        ...mapGetters( ['isStorageAvailableCountry', 'isDataAvailableCountry'] as const ),
        currentFeaturesList() {

            return [featuresList[1]];

        },
        userStatus (): string {

            return this.$store.state.user.status;

        },
        filteredServiceList(): IProductIntroduction[] {

            return this.servicesList.filter(( service ) => {

                if ( service.type === 'cloud-plan' && !this.isStorageAvailableCountry ) {

                    return !this.isDataAvailableCountry;

                }

                if ( service.type === 'sim-plan' && !this.isDataAvailableCountry ) {

                    return !this.isStorageAvailableCountry;

                }

                return true;

            });

        }
    }

});

</script>

<style scoped rel="stylesheet/css" lang="less">
    .services-intro{
        background-color: @bg_01;
        display: flex;
        flex-direction: column;
        padding: 35px 0;
        @media @mobile{
            gap: 24px;
        }
    }
</style>
